// RSF Drawer — toggle open/close. Triggers: data-open-drawer, data-close-drawer, Escape key.
(function () {
  'use strict';
  function initDrawer() {
    var drawer = document.querySelector('[data-rsf-drawer]');
    var overlay = document.querySelector('[data-rsf-drawer-overlay]');
    if (!drawer) return;

    var lastFocused = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function setTriggersActive(active) {
      var triggers = document.querySelectorAll('[data-open-rsf-drawer]');
      triggers.forEach(function (t) {
        if (active) t.classList.add('is-active');
        else t.classList.remove('is-active');
        // Swap text label if data-text-open / data-text-close defined (desktop MENU↔CLOSE)
        var openText = t.getAttribute('data-text-open');
        var closeText = t.getAttribute('data-text-close');
        if (openText && closeText) {
          (t.querySelector('.rsf-menu-btn__lbl') || t).textContent = active ? closeText : openText;
        }
      });
    }
    function closeOtherDrawers() {
      /* Search overlay */
      var searchOverlay = document.querySelector('[data-rsf-search-overlay]');
      if (searchOverlay && !searchOverlay.hidden) searchOverlay.hidden = true;
      var boostWrapper = document.querySelector('.boost-pfs-search-suggestion-wrapper');
      if (boostWrapper) boostWrapper.classList.remove('boost-pfs-search-suggestion-open');
      /* Cart drawer (custom element) */
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('active') && typeof cartDrawer.close === 'function') {
        cartDrawer.close();
      }
    }
    function open() {
      closeOtherDrawers();
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      setTriggersActive(true);
      // Nessun focus spostato all'apertura (richiesta esplicita): niente
      // voce/elemento preselezionato. Il focus-trap resta attivo se l'utente
      // naviga con Tab.
    }
    function close() {
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      setTriggersActive(false);
      // Restore focus al trigger che aveva aperto il drawer
      if (wasOpen && lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      lastFocused = null;
      // Clear search input + dismiss Boost popup so reopening shows fresh state
      var searchInput = drawer.querySelector('.rsf-drawer__search input.boost-pfs-search-input');
      if (searchInput && searchInput.value) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var boostWrapper = document.querySelector('.boost-pfs-search-suggestion-wrapper');
      if (boostWrapper) boostWrapper.classList.remove('boost-pfs-search-suggestion-open');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-rsf-drawer]')) {
        e.preventDefault();
        if (drawer.classList.contains('is-open')) close();
        else open();
      } else if (e.target.closest('[data-close-rsf-drawer]')) {
        e.preventDefault();
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      // Focus trap: con drawer aperto, Tab resta dentro il dialog
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); drawer.focus(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === drawer)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }
})();
